import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77ecfe7c")

_pushScopeId("data-v-77ecfe7c")
const _hoisted_1 = { class: "grid grid-cols-10" }
const _hoisted_2 = { class: "mb-2 xl:mb-0 xl:pl-2 col-span-10 lg:col-span-4 flex items-center justify-between h-10" }
const _hoisted_3 = { class: "font-semibold md:font-normal md:text-24" }
const _hoisted_4 = {
  key: 0,
  class: `col-span-10 lg:col-span-6 flex flex-row-reverse md:flex-row items-center
      justify-between lg:justify-end lg:h-10`
}
const _hoisted_5 = { class: "flex items-center justify-start lg:justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FilterSearch = _resolveComponent("FilterSearch")
  const _component_FilterSources = _resolveComponent("FilterSources")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('dashboard.filter-title', { count: _ctx.suggested })), 1),
      _createVNode(_component_FilterSearch, {
        modelValue: _ctx.searchString,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchString = $event)),
        class: "lg:hidden",
        onVisible: _cache[2] || (_cache[2] = ($event: any) => (_ctx.actionsVisible = true)),
        onHidden: _cache[3] || (_cache[3] = ($event: any) => (_ctx.actionsVisible = false))
      }, null, 8, ["modelValue"])
    ]),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_FilterSources, {
            modelValue: _ctx.selectedPlatforms,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedPlatforms = $event)),
            "platform-options": _ctx.platformOptions,
            "actions-visible": _ctx.actionsVisible
          }, null, 8, ["modelValue", "platform-options", "actions-visible"]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", {
              class: [!_ctx.actionsVisible && 'lg:hidden', "flex items-center"]
            }, [
              _createVNode("button", {
                class: [
              _ctx.selectedOrientations.includes('vertical') ?  'border-btn-primary' : 'border-btn-light',
              `focus:outline-none flex rounded w-8 h-8 px-2 bg-white border`
            ],
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleOrientation('vertical')))
              }, [
                _createVNode("img", {
                  class: "m-auto",
                  src: _ctx.selectedOrientations.includes('vertical')
                ? require('@/assets/svg/image-vertical-dark.svg')
                : require('@/assets/svg/image-vertical.svg'),
                  atl: "vertical orientation"
                }, null, 8, ["src"])
              ], 2),
              _createVNode("button", {
                class: [
              _ctx.selectedOrientations.includes('horizontal') ?  'border-btn-primary' : 'border-btn-light',
              `focus:outline-none flex rounded w-8 h-8 px-1 ml-2 bg-white border`
            ],
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleOrientation('horizontal')))
              }, [
                _createVNode("img", {
                  class: "m-auto",
                  src: _ctx.selectedOrientations.includes('horizontal')
                ? require('@/assets/svg/image-horizontal-dark.svg')
                : require('@/assets/svg/image-horizontal.svg'),
                  atl: "horizontal orientation"
                }, null, 8, ["src"])
              ], 2),
              _createVNode("button", {
                class: [
              _ctx.selectedOrientations.includes('square') ?  'border-btn-primary' : 'border-btn-light',
              `focus:outline-none flex rounded w-8 h-8 px-1.5 ml-2 bg-white border`
            ],
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleOrientation('square')))
              }, [
                _createVNode("img", {
                  class: "m-auto",
                  src: _ctx.selectedOrientations.includes('square')
                ? require('@/assets/svg/image-square-dark.svg')
                : require('@/assets/svg/image-square.svg'),
                  atl: "square orientation"
                }, null, 8, ["src"])
              ], 2)
            ], 2),
            _createVNode(_component_FilterSearch, {
              modelValue: _ctx.searchString,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.searchString = $event)),
              class: "hidden lg:flex",
              onVisible: _cache[9] || (_cache[9] = ($event: any) => (_ctx.actionsVisible = true)),
              onHidden: _cache[10] || (_cache[10] = ($event: any) => (_ctx.actionsVisible = false))
            }, null, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})